const Sercardapi = [
    {
        id: 1,
        title: "Web Development",
        desc: "In my Services there is a Website Development",
        icon: "fa-solid fa-code"
    },
    {
        id: 2,
        title: "App Development",
        desc: "In my Services there is a Application Development",
        icon: "fa-solid fa-mobile"
    },
    {
        id: 3,
        title: "Digital Marketing",
        desc: "In my Services there is a Digital Marketing",
        icon: "fa-solid fa-bullhorn"
    },
    {
        id: 4,
        title: "Unique Design",
        desc: "In my Services there is a Unique Design",
        icon: "fa-solid fa-palette"
    },
    {
        id: 5,
        title: "Content Production",
        desc: "In my Services there is a Content Production",
        icon: "fa-sharp fa-solid fa-handshake-angle"
    },
    {
        id: 6,
        title: "Analytics",
        desc: "In my Services there is a Application Development Website Development",
        icon: "fa-regular fa-magnifying-glass"
    },
]

export default Sercardapi;